// Quiz State (data configuration is in quiz-data.js)
let currentQuestion = 0;
let userAnswers = [];
let scores = {};
let selectedAnswerIndex = null;

// Initialize Quiz
function initQuiz() {
  // Welcome screen is shown by default
  // Quiz starts when user clicks "Start Quiz" button
}

// Start Quiz from welcome screen with gender selection
function startQuiz(gender) {
  // Store gender separately (not tied to a question)
  window.dogGender = gender;

  // Track quiz start
  if (typeof gtag !== 'undefined') {
    const screenWidth = window.innerWidth;
    const deviceType = screenWidth < 768 ? 'mobile' : (screenWidth < 1024 ? 'tablet' : 'desktop');

    gtag('event', 'quiz_started', {
      gender: gender,
    });
  }

  // Start from question 1 (index 0)
  currentQuestion = 0;

  // Hide welcome section
  document.getElementById('welcome-section').style.display = 'none';

  // Show quiz elements
  document.querySelector('.quiz-header').style.display = 'grid';
  document.querySelector('.progress-bar').style.display = 'block';
  document.getElementById('quiz-questions').style.display = 'block';

  // Render first question
  renderQuestion();
  updateProgress();
}

// Render Current Question
function renderQuestion() {
  const question = quizData.questions[currentQuestion];
  const questionsContainer = document.getElementById('quiz-questions');
  const quizHeader = document.querySelector('.quiz-header');

  // Scroll to top of questions container
  questionsContainer.scrollTop = 0;

  // Track question view
  if (typeof gtag !== 'undefined') {
    const screenWidth = window.innerWidth;
    const deviceType = screenWidth < 768 ? 'mobile' : (screenWidth < 1024 ? 'tablet' : 'desktop');

    gtag('event', 'question_viewed', {
      question_id: question.id,
      question_number: currentQuestion + 1,
      question_number_padded: 'Q' + String(currentQuestion + 1).padStart(2, '0'),
    });
  }

  // Update header with back button and counter
  quizHeader.innerHTML = `
    <div class="header-left">
      ${currentQuestion > 0 ? `<button class="back-btn" onclick="previousQuestion()"><img src="${window.LEFT_ARROW_URL}" alt="Back" class="back-arrow-icon"></button>` : '<div></div>'}
    </div>
    <div class="header-center">
      <img src="${window.LOGO_URL}" alt="Logo" class="logo">
    </div>
    <div class="header-right">
      <span class="page-counter">${currentQuestion + 1} / ${quizData.questions.length}</span>
    </div>
  `;

  // Replace {dogName} variable with actual dog's name
  let questionText = question.question;
  if (questionText.includes('{dogName}')) {
    const dogNameAnswer = userAnswers.find(answer => answer && answer.questionId === 2);
    const dogName = dogNameAnswer ? dogNameAnswer.answerText : 'your dog';
    questionText = questionText.replace('{dogName}', dogName);
  }

  // Check if question is text input type
  if (question.type === 'text') {
    questionsContainer.innerHTML = `
      <div class="question-wrapper fade-in">
        ${question.sectionTitle ? `<h3 class="section-title">${question.sectionTitle}</h3>` : ''}
        <h2 class="question-text">${questionText}</h2>
        ${question.subtitle ? `<p class="question-subtitle">${question.subtitle}</p>` : ''}
        <div class="text-input-container">
          <input
            type="text"
            id="text-input"
            class="text-input-field"
            placeholder="${question.placeholder || 'Enter your answer'}"
            value="${userAnswers[currentQuestion]?.answerText || ''}"
          >
        </div>
        <div class="quiz-actions">
          <button class="continue-btn" id="continue-btn" onclick="continueToNext()" disabled>Continue</button>
        </div>
      </div>
    `;

    // Enable continue button when text is entered
    const textInput = document.getElementById('text-input');
    const continueBtn = document.getElementById('continue-btn');

    // Check if there's existing text
    if (textInput.value.trim()) {
      continueBtn.disabled = false;
    }

    textInput.addEventListener('input', (e) => {
      selectedAnswerIndex = e.target.value.trim() ? 0 : null; // Use 0 as placeholder index
      continueBtn.disabled = !e.target.value.trim();
    });

    // Close keyboard when Enter key is pressed
    textInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        textInput.blur(); // This closes the keyboard on mobile
      }
    });
  } else {
    // Multiple choice question
    questionsContainer.innerHTML = `
      <div class="question-wrapper fade-in">
        ${question.sectionTitle ? `<h3 class="section-title">${question.sectionTitle}</h3>` : ''}
        <h2 class="question-text">${questionText}</h2>
        ${question.subtitle ? `<p class="question-subtitle">${question.subtitle}</p>` : ''}
        <div class="answers-grid">
          ${question.answers.map((answer, index) => `
            <button class="answer-btn" onclick="selectAnswer(${index})">
              <div class="answer-content">
                <span class="answer-circle"></span>
                <span class="answer-text">${answer.text}</span>
              </div>
            </button>
          `).join('')}
        </div>
        <div class="quiz-actions">
          <button class="continue-btn" id="continue-btn" onclick="continueToNext()" disabled>Continue</button>
        </div>
      </div>
    `;
  }

  // Reset selected answer
  selectedAnswerIndex = null;

  // If there was a previous answer for this question, show it as selected
  if (userAnswers[currentQuestion]) {
    const previousAnswerIndex = userAnswers[currentQuestion].answerIndex;
    setTimeout(() => {
      const buttons = document.querySelectorAll('.answer-btn');
      if (buttons[previousAnswerIndex]) {
        buttons[previousAnswerIndex].classList.add('selected');
        selectedAnswerIndex = previousAnswerIndex;

        // Enable continue button
        const continueBtn = document.getElementById('continue-btn');
        if (continueBtn) {
          continueBtn.disabled = false;
        }
      }
    }, 0);
  }
}

// Handle Answer Selection
function selectAnswer(answerIndex) {
  // Remove selected class from all buttons
  const buttons = document.querySelectorAll('.answer-btn');
  buttons.forEach(btn => btn.classList.remove('selected'));

  // Add selected class to clicked button
  buttons[answerIndex].classList.add('selected');

  // Store selected answer index
  selectedAnswerIndex = answerIndex;

  // Enable continue button
  const continueBtn = document.getElementById('continue-btn');
  continueBtn.disabled = false;
}

// Continue to next question
function continueToNext() {
  const question = quizData.questions[currentQuestion];

  // Handle text input questions
  if (question.type === 'text') {
    const textInput = document.getElementById('text-input');
    const inputValue = textInput.value.trim();

    if (!inputValue) return;

    // Store user answer
    userAnswers[currentQuestion] = {
      questionId: question.id,
      answerText: inputValue,
      answerIndex: 0 // Placeholder index for text inputs
    };
  } else {
    // Handle multiple choice questions
    if (selectedAnswerIndex === null) return;

    const answer = question.answers[selectedAnswerIndex];

    // If there was a previous answer, subtract its score first
    if (userAnswers[currentQuestion]) {
      const previousAnswer = question.answers[userAnswers[currentQuestion].answerIndex];
      scores.total = (scores.total || 0) - previousAnswer.score;
    }

    // Store user answer
    userAnswers[currentQuestion] = {
      questionId: question.id,
      answerText: answer.text,
      answerIndex: selectedAnswerIndex,
      score: answer.score
    };

    // Accumulate score
    scores.total = (scores.total || 0) + answer.score;
  }

  currentQuestion++;

  // Check if we just finished question with id 5 (show info page 0)
  const previousQuestion = quizData.questions[currentQuestion - 1];
  // if (previousQuestion && previousQuestion.id === 5) {
  //   showInfoPage0();
  //   return;
  // }

  // Check if we just finished question with id 8 (show info page 1)
  if (previousQuestion && previousQuestion.id === 8) {
    showInfoPage1();
    return;
  }

  // Check if we just finished question 15 (Crate Training)
  if (previousQuestion && previousQuestion.id === 15) {
    const question15Answer = userAnswers.find(a => a && a.questionId === 15);
    // If answer is "No, and I don't want to" (index 2), skip questions 16-18
    if (question15Answer && question15Answer.answerIndex === 2) {
      // Skip to question 19 (find the index where id === 19)
      const question19Index = quizData.questions.findIndex(q => q.id === 19);
      if (question19Index !== -1) {
        currentQuestion = question19Index;
      }
    }
  }

  // Check if we just finished question 34
  if (previousQuestion && previousQuestion.id === 34) {
    const question34Answer = userAnswers.find(a => a && a.questionId === 34);
    // If answer is "Yes, and I like it" (index 0), skip questions 35-37
    if (question34Answer && question34Answer.answerIndex === 0) {
      // Skip to question 38 (find the index where id === 38)
      const question38Index = quizData.questions.findIndex(q => q.id === 38);
      if (question38Index !== -1) {
        currentQuestion = question38Index;
      }
    }
  }

  // Check if we just finished question with id 27 (show info page 2)
  if (previousQuestion && previousQuestion.id === 27) {
    showInfoPage2();
    return;
  }

  // Check if we just finished question with id 46 (show info page 3)
  if (previousQuestion && previousQuestion.id === 46) {
    showInfoPage3();
    return;
  }

  if (currentQuestion < quizData.questions.length) {
    renderQuestion();
    updateProgress();
  } else {
    // All questions finished, go to results
    showResults();
  }
}

// Go to Previous Question
function previousQuestion() {
  // Can't go back before question 1 (index 0) since gender is on welcome screen
  if (currentQuestion > 0) {
    const currentQ = quizData.questions[currentQuestion];

    // Check if we're currently AT question 19 and should skip back
    if (currentQ && currentQ.id === 19) {
      // Check if user answered question 15 with "No, and I don't want to"
      const question15Answer = userAnswers.find(a => a && a.questionId === 15);
      if (question15Answer && question15Answer.answerIndex === 2) {
        // Go back to question 15 instead of 18
        const question15Index = quizData.questions.findIndex(q => q.id === 15);
        if (question15Index !== -1) {
          currentQuestion = question15Index;
          renderQuestion();
          updateProgress();
          return;
        }
      }
    }

    // Check if we're currently AT question 38 and should skip back
    if (currentQ && currentQ.id === 38) {
      // Check if user answered question 34 with "Yes, and I like it"
      const question34Answer = userAnswers.find(a => a && a.questionId === 34);
      if (question34Answer && question34Answer.answerIndex === 0) {
        // Go back to question 34 instead of 37
        const question34Index = quizData.questions.findIndex(q => q.id === 34);
        if (question34Index !== -1) {
          currentQuestion = question34Index;
          renderQuestion();
          updateProgress();
          return;
        }
      }
    }

    // Normal back navigation
    currentQuestion--;
    renderQuestion();
    updateProgress();
  }
}

// Update Progress Bar
function updateProgress() {
  const progressFill = document.getElementById('progress-fill');
  const progressPercentage = (currentQuestion / quizData.questions.length) * 100;
  progressFill.style.width = progressPercentage + '%';
}

// Show Info Page 0 (after question 5)
function showInfoPage0() {
  // Hide progress bar and header
  document.querySelector('.progress-bar').style.display = 'none';
  document.querySelector('.quiz-header').style.display = 'none';

  // Hide questions section
  document.getElementById('quiz-questions').style.display = 'none';

  // Get dog's name and update title
  const dogNameAnswer = userAnswers.find(answer => answer && answer.questionId === 2);
  const dogName = dogNameAnswer ? dogNameAnswer.answerText : 'your dog';
  const titleElement = document.querySelector('#info-page-0-title');
  if (titleElement) {
    titleElement.innerHTML = `Thank you!<br>We're now creating the first part of ${dogName}'s personalized plan.`;
  }

  // Show info page 0
  document.getElementById('info-page-0').style.display = 'block';

  // After 5 seconds, show 100% and enable the continue button
  setTimeout(() => {
    // Stop spinner animation and show 100%
    const spinner = document.querySelector('#info-page-0-spinner');
    spinner.style.animation = 'none';
    spinner.classList.add('completed');
    document.getElementById('info-page-0-percentage').style.display = 'block';

    const titleElement = document.querySelector('#info-page-0-title');

    // First fade out the current text
    if (titleElement) {
      titleElement.classList.add('fade-out-text');
    }

    // After fade out completes, change text and fade in
    setTimeout(() => {
      // Update title to completion message
      if (titleElement) {
        titleElement.textContent = 'All done!';
        titleElement.classList.remove('fade-out-text');
        titleElement.classList.add('fade-in-text');
      }

      // Enable continue button
      document.getElementById('info-page-0-continue-btn').disabled = false;
    }, 500); // Wait for fade out animation
  }, 5000);
}

// Continue from Info Page 0 to next question
function continueFromInfoPage0() {
  // Hide info page 0
  document.getElementById('info-page-0').style.display = 'none';

  // Reset spinner state for next time
  const spinner = document.querySelector('#info-page-0-spinner');
  spinner.style.animation = 'spin 1s linear infinite';
  spinner.classList.remove('completed');
  document.getElementById('info-page-0-percentage').style.display = 'none';
  document.getElementById('info-page-0-continue-btn').disabled = true;

  // Reset text animation classes
  const titleElement = document.querySelector('#info-page-0-title');
  if (titleElement) {
    titleElement.classList.remove('fade-out-text', 'fade-in-text');
  }

  // Show quiz questions section
  document.getElementById('quiz-questions').style.display = 'block';

  // Show progress bar and header again
  document.querySelector('.progress-bar').style.display = 'block';
  document.querySelector('.quiz-header').style.display = 'grid';

  // Continue to next question
  renderQuestion();
  updateProgress();
}

// Show Info Page 1 (after question 8)
function showInfoPage1() {
  // Hide progress bar and header
  document.querySelector('.progress-bar').style.display = 'none';
  document.querySelector('.quiz-header').style.display = 'none';

  // Hide questions section
  document.getElementById('quiz-questions').style.display = 'none';

  // Show info page 1
  document.getElementById('info-page-1').style.display = 'block';
}

// Continue from Info Page 1 to next question
function continueFromInfoPage1() {
  // Hide info page 1
  document.getElementById('info-page-1').style.display = 'none';

  // Show quiz questions section
  document.getElementById('quiz-questions').style.display = 'block';

  // Show progress bar and header again
  document.querySelector('.progress-bar').style.display = 'block';
  document.querySelector('.quiz-header').style.display = 'grid';

  // Continue to next question
  renderQuestion();
  updateProgress();
}

// Show Info Page 2 (after question 27)
function showInfoPage2() {
  // Hide progress bar and header
  document.querySelector('.progress-bar').style.display = 'none';
  document.querySelector('.quiz-header').style.display = 'none';

  // Hide questions section
  document.getElementById('quiz-questions').style.display = 'none';

  // Show info page 2
  document.getElementById('info-page-2').style.display = 'block';
}

// Continue from Info Page 2 to next question
function continueFromInfoPage2() {
  // Hide info page 2
  document.getElementById('info-page-2').style.display = 'none';

  // Show quiz questions section
  document.getElementById('quiz-questions').style.display = 'block';

  // Show progress bar and header again
  document.querySelector('.progress-bar').style.display = 'block';
  document.querySelector('.quiz-header').style.display = 'grid';

  // Continue to next question
  renderQuestion();
  updateProgress();
}

// Show Info Page 3 (after question 46)
function showInfoPage3() {
  // Hide progress bar and header
  document.querySelector('.progress-bar').style.display = 'none';
  document.querySelector('.quiz-header').style.display = 'none';

  // Hide questions section
  document.getElementById('quiz-questions').style.display = 'none';

  // Get dog's name and update title
  const dogNameAnswer = userAnswers.find(answer => answer && answer.questionId === 2);
  const dogName = dogNameAnswer ? dogNameAnswer.answerText : 'your dog';
  const titleElement = document.querySelector('#info-page-3 .welcome-title');
  if (titleElement) {
    titleElement.textContent = `Personalizing ${dogName}'s evaluation & training plan...`;
  }

  // Show info page 3
  document.getElementById('info-page-3').style.display = 'block';

  // After 4 seconds, show 100% and enable the continue button
  setTimeout(() => {
    // Stop spinner animation and show 100%
    const spinner = document.querySelector('#info-page-3 .spinner');
    spinner.style.animation = 'none';
    spinner.classList.add('completed');
    document.getElementById('spinner-percentage').style.display = 'block';

    const titleElement = document.querySelector('#info-page-3 .welcome-title');
    const descriptionElement = document.querySelector('#info-page-3 .welcome-description');

    // First fade out the current text
    if (titleElement) {
      titleElement.classList.add('fade-out-text');
    }
    if (descriptionElement) {
      descriptionElement.classList.add('fade-out-text');
    }

    // After fade out completes, change text and fade in
    setTimeout(() => {
      // Update title to completion message
      if (titleElement) {
        titleElement.textContent = `${dogName}'s evaluation & training plan is set!`;
        titleElement.classList.remove('fade-out-text');
        titleElement.classList.add('fade-in-text');
      }

      // Hide the waiting message (keep space to prevent jumping)
      if (descriptionElement) {
        descriptionElement.style.opacity = '0';
        descriptionElement.style.visibility = 'hidden';
      }

      // Enable continue button
      document.getElementById('info-page-3-continue-btn').disabled = false;
    }, 300); // Wait for fade out animation (0.3s)
  }, 4000);
}

// Continue from Info Page 3 to next question or results
function continueFromInfoPage3() {
  // Hide info page 3
  document.getElementById('info-page-3').style.display = 'none';

  // Reset spinner state for next time
  const spinner = document.querySelector('#info-page-3 .spinner');
  spinner.style.animation = 'spin 1s linear infinite';
  spinner.classList.remove('completed');
  document.getElementById('spinner-percentage').style.display = 'none';
  document.getElementById('info-page-3-continue-btn').disabled = true;

  // Reset text animation classes
  const titleElement = document.querySelector('#info-page-3 .welcome-title');
  const descriptionElement = document.querySelector('#info-page-3 .welcome-description');

  if (titleElement) {
    titleElement.classList.remove('fade-out-text', 'fade-in-text');
  }

  if (descriptionElement) {
    descriptionElement.style.opacity = '1';
    descriptionElement.style.visibility = 'visible';
    descriptionElement.classList.remove('fade-out-text', 'fade-in-text');
  }

  // Check if there are more questions
  if (currentQuestion < quizData.questions.length) {
    // Show quiz questions section
    document.getElementById('quiz-questions').style.display = 'block';

    // Show progress bar and header again
    document.querySelector('.progress-bar').style.display = 'block';
    document.querySelector('.quiz-header').style.display = 'grid';

    // Continue to next question
    renderQuestion();
    updateProgress();
  } else {
    // No more questions, show results
    showResults();
  }
}

// Calculate and Show Results
function showResults() {
  // Calculate scores per group
  const groupScores = {};
  userAnswers.forEach(answer => {
    if (!answer) return;
    // Skip text inputs (which don't have score property)
    if (!answer.hasOwnProperty('score')) return;

    const question = quizData.questions.find(q => q.id === answer.questionId);
    if (!question || !question.group) return;

    if (!groupScores[question.group]) {
      groupScores[question.group] = 0;
    }
    groupScores[question.group] += answer.score;
  });

  // Get the total score
  const totalScore = scores.total || 0;

  // Update header to show only logo on results page
  const quizHeader = document.querySelector('.quiz-header');
  quizHeader.innerHTML = `
    <div class="header-left"></div>
    <div class="header-center">
      <img src="${window.LOGO_URL}" alt="Logo" class="logo">
    </div>
    <div class="header-right"></div>
  `;

  // Hide progress bar
  const progressBar = document.querySelector('.progress-bar');
  progressBar.style.display = 'none';

  // Hide questions, show results
  document.getElementById('quiz-questions').style.display = 'none';
  const resultsContainer = document.getElementById('quiz-results');
  resultsContainer.style.display = 'block';

  // Get dog's name from answers (question id 2)
  const dogNameAnswer = userAnswers.find(answer => answer && answer.questionId === 2);
  const dogName = dogNameAnswer ? dogNameAnswer.answerText : 'Your dog';

  // Get profile data
  const ageAnswer = userAnswers.find(answer => answer && answer.questionId === 1);
  const breedAnswer = userAnswers.find(answer => answer && answer.questionId === 3);
  const experienceAnswer = userAnswers.find(answer => answer && answer.questionId === 4);
  const socialAnswer = userAnswers.find(answer => answer && answer.questionId === 5);

  // Populate profile box
  document.getElementById('profile-header').textContent = `${dogName}'s Profile`;
  document.getElementById('profile-age').textContent = ageAnswer ? ageAnswer.answerText : 'N/A';
  document.getElementById('profile-gender').textContent = window.dogGender || 'N/A';
  document.getElementById('profile-breed').textContent = breedAnswer ? breedAnswer.answerText : 'N/A';
  document.getElementById('profile-experience').textContent = experienceAnswer ? experienceAnswer.answerText : 'N/A';
  document.getElementById('profile-social').textContent = socialAnswer ? socialAnswer.answerText : 'N/A';

  // Calculate overall behavior score percentage
  const totalEarnedPoints = Object.values(groupScores).reduce((sum, score) => sum + score, 0);
  const totalPossiblePoints = calculateTotalPossibleScore();

  // Invert: higher points = worse behavior = lower percentage
  const scorePercentage = totalPossiblePoints > 0 ? 100 - Math.round((totalEarnedPoints / totalPossiblePoints) * 100) : 0;
  document.getElementById('score-percentage').textContent = `${scorePercentage}%`;

  // Calculate max possible points for each group
  const groupMaxPoints = {};
  quizData.questions.forEach(question => {
    if (!question.group || !question.answers) return;

    if (!groupMaxPoints[question.group]) {
      groupMaxPoints[question.group] = 0;
    }

    // Find max score among answers
    const maxScore = Math.max(...question.answers.map(a => a.score));
    groupMaxPoints[question.group] += maxScore;
  });

  // Check if crate questions were skipped (Q16-18)
  const q15Answer = userAnswers.find(a => a && a.questionId === 15);
  if (q15Answer && q15Answer.answerIndex === 2 && groupMaxPoints.crate) {
    groupMaxPoints.crate -= 9;
  }

  // Check if bed questions were skipped (Q35-37)
  const q34Answer = userAnswers.find(a => a && a.questionId === 34);
  if (q34Answer && q34Answer.answerIndex === 0 && groupMaxPoints.bed) {
    groupMaxPoints.bed -= 9;
  }

  // Create mapping from group to sectionTitle
  const groupToSectionTitle = {};
  quizData.questions.forEach(question => {
    if (question.group && question.sectionTitle && !groupToSectionTitle[question.group]) {
      groupToSectionTitle[question.group] = question.sectionTitle;
    }
  });

  // Calculate percentage for each group and categorize
  const categorizedGroups = {
    needsImprovement: [],
    satisfactory: [],
    excellent: []
  };

  Object.keys(groupScores).forEach(groupName => {
    // Skip general group
    if (groupName === 'general') return;

    // Skip crate group if user doesn't want crate training
    if (groupName === 'crate' && q15Answer && q15Answer.answerIndex === 2) return;

    // Skip bed group if user likes dog on bed
    if (groupName === 'bed' && q34Answer && q34Answer.answerIndex === 0) return;

    const earnedPoints = groupScores[groupName];
    const maxPoints = groupMaxPoints[groupName] || 1;
    // Invert: higher points = worse behavior = lower percentage
    let percentage = 100 - Math.round((earnedPoints / maxPoints) * 100);

    // Show 6% instead of 0%
    if (percentage === 0) {
      percentage = 6;
    }

    const displayName = groupToSectionTitle[groupName] || groupName;
    const groupData = { name: displayName, percentage };

    if (percentage <= 33) {
      categorizedGroups.needsImprovement.push(groupData);
    } else if (percentage <= 66) {
      categorizedGroups.satisfactory.push(groupData);
    } else {
      categorizedGroups.excellent.push(groupData);
    }
  });

  // Sort each category by percentage (lowest first = worst behavior on top)
  categorizedGroups.needsImprovement.sort((a, b) => a.percentage - b.percentage);
  categorizedGroups.satisfactory.sort((a, b) => a.percentage - b.percentage);
  categorizedGroups.excellent.sort((a, b) => a.percentage - b.percentage);

  // Display categorized groups
  const needsImprovementEl = document.getElementById('behavior-needs-improvement');
  const satisfactoryEl = document.getElementById('behavior-satisfactory');
  const excellentEl = document.getElementById('behavior-excellent');

  // Needs Improvement section
  if (categorizedGroups.needsImprovement.length > 0) {
    needsImprovementEl.innerHTML = categorizedGroups.needsImprovement
      .map(g => `<p class="profile-item"><span class="profile-label">${g.name}</span> <span style="font-weight: 600; color: #F92323;">${g.percentage}%</span></p>`)
      .join('');
    needsImprovementEl.parentElement.style.display = 'block';
  } else {
    needsImprovementEl.parentElement.style.display = 'none';
  }

  // Satisfactory section
  if (categorizedGroups.satisfactory.length > 0) {
    satisfactoryEl.innerHTML = categorizedGroups.satisfactory
      .map(g => `<p class="profile-item"><span class="profile-label">${g.name}</span> <span style="font-weight: 600; color: #FFCC00;">${g.percentage}%</span></p>`)
      .join('');
    satisfactoryEl.parentElement.style.display = 'block';
  } else {
    satisfactoryEl.parentElement.style.display = 'none';
  }

  // Excellent section
  if (categorizedGroups.excellent.length > 0) {
    excellentEl.innerHTML = categorizedGroups.excellent
      .map(g => `<p class="profile-item"><span class="profile-label">${g.name}</span> <span style="font-weight: 600; color: #5FB868;">${g.percentage}%</span></p>`)
      .join('');
    excellentEl.parentElement.style.display = 'block';
  } else {
    excellentEl.parentElement.style.display = 'none';
  }

  // Calculate group percentages and categorize
  const groupPercentages = {};
  Object.keys(groupScores).forEach(groupName => {
    if (groupName === 'general') return;
    const earnedPoints = groupScores[groupName];
    const maxPoints = groupMaxPoints[groupName] || 1;
    // Invert: higher points = worse behavior = lower percentage
    const percentage = 100 - Math.round((earnedPoints / maxPoints) * 100);
    groupPercentages[groupName] = {
      percentage,
      earnedPoints,
      needsProgram: percentage <= 66 // Needs improvement (0-33%) or satisfactory (34-66%)
    };
  });

  // Priority programs in order
  const priorityOrder = [
    { group: 'potty', programId: 1 },
    { group: 'reactivity', programId: 2 },
    { group: 'separation', programId: 3 },
    { group: 'crate', programId: 12 },
    { group: 'scavenging', programId: 4 },
    { group: 'leash', programId: 6 }
  ];

  // Check if crate training was skipped (user doesn't want it) - reuse q15Answer from earlier
  const crateSkipped = q15Answer && q15Answer.answerIndex === 2;

  // Check if bed training was skipped (user already likes it on bed) - reuse q34Answer from earlier
  const bedSkipped = q34Answer && q34Answer.answerIndex === 0;

  // Check if dog is 0-6 months old (question 1, answer index 0)
  const isPuppy = ageAnswer && ageAnswer.answerIndex === 0;

  // Build recommended programs list
  const recommendedPrograms = [];
  const usedProgramIds = new Set();

  // If puppy (0-6 months), add Puppy socialization & basics first
  if (isPuppy) {
    const puppyProgram = programData.programs.find(p => p.id === 11);
    if (puppyProgram) {
      recommendedPrograms.push(puppyProgram);
      usedProgramIds.add(11);
    }
  }

  // Add priority programs if their group needs program
  priorityOrder.forEach(({ group, programId }) => {
    // Skip crate if user doesn't want it
    if (group === 'crate' && crateSkipped) return;

    if (groupPercentages[group] && groupPercentages[group].needsProgram) {
      const program = programData.programs.find(p => p.id === programId);
      if (program) {
        recommendedPrograms.push(program);
        usedProgramIds.add(programId);
      }
    }
  });

  // Add remaining programs sorted by group score (worst first - higher score = worse)
  const remainingPrograms = programData.programs
    .filter(program => {
      // Skip already used programs
      if (usedProgramIds.has(program.id)) return false;
      // Skip crate training if user doesn't want it
      if (program.id === 12 && crateSkipped) return false;
      // Skip bed training if user likes dog on bed
      if (program.id === 13 && bedSkipped) return false;
      return true;
    })
    .map(program => {
      // Find the group's earned points for this program
      const groupName = program.relatedGroups[0];
      const earnedPoints = groupPercentages[groupName]?.earnedPoints || 0;
      return { program, earnedPoints };
    })
    .sort((a, b) => b.earnedPoints - a.earnedPoints) // Sort descending (worst first)
    .map(item => item.program);

  const allRecommendedPrograms = [...recommendedPrograms, ...remainingPrograms];

  // Populate programs container (limit to 5)
  const programsContainer = document.getElementById('recommended-programs');
  programsContainer.innerHTML = allRecommendedPrograms
    .slice(0, 5)
    .map(program => `
      <div class="program-item">
        <div class="program-number"></div>
        <div class="program-content">
          <h4 class="program-title">${program.title}</h4>
          <p class="program-description">${program.description}</p>
        </div>
        <div class="program-image">
          <img src="${program.image}" alt="${program.title}">
        </div>
      </div>
    `).join('');

  // Track quiz completion
  if (typeof gtag !== 'undefined') {
    const screenWidth = window.innerWidth;
    const deviceType = screenWidth < 768 ? 'mobile' : (screenWidth < 1024 ? 'tablet' : 'desktop');

    gtag('event', 'quiz_completed', {
      total_score_percentage: scorePercentage,
      dog_name: dogName,
      dog_age: ageAnswer ? ageAnswer.answerText : 'N/A',
    });
  }
}

function calculateTotalPossibleScore() {
  let actualPoints = 118

  const q15Answer = userAnswers.find(a => a && a.questionId === 15);
  if (q15Answer && q15Answer.answerIndex === 2) {
    actualPoints -= 9
  }

  const q34Answer = userAnswers.find(a => a && a.questionId === 34);
  if (q34Answer && q34Answer.answerIndex === 0) {
    actualPoints -= 9
  }

  return actualPoints
}

// Save Results
function saveResults(result) {
  const resultsData = {
    timestamp: new Date().toISOString(),
    result: result.title,
    gender: window.dogGender,
    answers: userAnswers,
    totalScore: scores.total || 0
  };

  localStorage.setItem('quizResults', JSON.stringify(resultsData));
}

// Email Results (placeholder function)
function emailResults() {
  const email = prompt('Enter your email address to receive your personalized results:');

  if (email && email.includes('@')) {
    alert('Great! Your results have been sent to ' + email);
    // In production, you would send this to your backend/email service
  } else if (email) {
    alert('Please enter a valid email address.');
  }
}

// Restart Quiz
function restartQuiz() {
  currentQuestion = 0;
  userAnswers = [];
  scores = {};
  selectedAnswerIndex = null;

  // Hide results
  document.getElementById('quiz-results').style.display = 'none';

  // Hide quiz elements
  document.querySelector('.quiz-header').style.display = 'none';
  document.querySelector('.progress-bar').style.display = 'none';
  document.getElementById('quiz-questions').style.display = 'none';
  document.getElementById('info-page-1').style.display = 'none';
  document.getElementById('info-page-2').style.display = 'none';
  document.getElementById('info-page-3').style.display = 'none';

  // Show welcome section again
  document.getElementById('welcome-section').style.display = 'block';
}

// Make jumpToQuestion available globally for console testing
window.jumpToQuestion = jumpToQuestion;

// Initialize quiz when page loads
document.addEventListener('DOMContentLoaded', initQuiz);

function jumpToQuestion(questionId, q15AnswerIndex = 0, q34AnswerIndex = 1) {
  // Set gender
  window.dogGender = 'Boy';

  // Find the target question index
  const targetIndex = quizData.questions.findIndex(q => q.id === questionId);
  if (targetIndex === -1) {
    console.error('Question ID not found:', questionId);
    return;
  }

  // Fill dummy answers for all previous questions
  userAnswers = [];
  scores = { total: 0 };

  for (let i = 0; i < targetIndex; i++) {
    const question = quizData.questions[i];

    if (question.type === 'text') {
      // Fill with dummy text
      userAnswers[i] = {
        questionId: question.id,
        answerText: question.id === 2 ? 'Max' : 'Test answer',
        answerIndex: 0
      };
    } else {
      // Use specific answer index for questions 15 and 34, otherwise use index 0
      let answerIndex = 2;
      if (question.id === 15) {
        answerIndex = q15AnswerIndex;
      } else if (question.id === 34) {
        answerIndex = q34AnswerIndex;
      }

      const answer = question.answers[answerIndex];
      userAnswers[i] = {
        questionId: question.id,
        answerText: answer.text,
        answerIndex: answerIndex,
        score: answer.score
      };
      scores.total += answer.score;
    }
  }

  // Set current question to target
  currentQuestion = targetIndex;

  // Hide welcome, show quiz
  document.getElementById('welcome-section').style.display = 'none';
  document.querySelector('.quiz-header').style.display = 'grid';
  document.querySelector('.progress-bar').style.display = 'block';
  document.getElementById('quiz-questions').style.display = 'block';

  // Hide info pages
  document.getElementById('info-page-1').style.display = 'none';
  document.getElementById('info-page-2').style.display = 'none';
  document.getElementById('info-page-3').style.display = 'none';

  // Render the target question
  renderQuestion();
  updateProgress();
}

// Redirect to membership page with tracking
function redirectToMembership() {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'redirect_to_membership');
  }

  // Small delay to ensure tracking fires before redirect
  setTimeout(() => {
    window.location.href = 'https://wiglo.dog/collections/membership';
  }, 200);
}
